function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    // enableSwatches(swatches, image) {
    //   let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
    //     org_srcset = image ? image.dataset.srcset : '';
    //   this.color_index = this.swatches.dataset.index;

    //   swatch_list.forEach((swatch, index) => {
    //     window.addEventListener('load', (event) => {
    //       let image = new Image();
    //       image.srcset = swatch.dataset.srcset;
    //       lazySizes.loader.unveil(image);
    //     });

    //     swatch.addEventListener('mouseover', () => {
    //       [].forEach.call(swatch_list, function (el) {
    //         el.classList.remove('active');
    //       });
    //       if (image) {
    //         if (swatch.dataset.srcset) {
    //           image.setAttribute('srcset', swatch.dataset.srcset);
    //         } else {
    //           image.setAttribute('srcset', org_srcset);
    //         }
    //       }
    //       if (this.size_options) {
    //         this.current_options[this.color_index] = swatch.querySelector('span').innerText;
    //         this.updateMasterId();
    //       }
    //       swatch.classList.add('active');
    //     });
    //     swatch.addEventListener('click', function (evt) {
    //       window.location.href = this.dataset.href;
    //       evt.preventDefault();
    //     });
    //   });
    // }
    enableSwatches(swatches, image) {
    let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

    this.color_index = this.swatches.dataset.index;

    swatch_list.forEach((swatch) => {

      window.addEventListener('load', () => {
        let preloadImg = new Image();
        preloadImg.srcset = swatch.dataset.srcset;
        lazySizes.loader.unveil(preloadImg);
      });

      const handleSwatch = () => {
        // Active state
        swatch_list.forEach(el => el.classList.remove('active'));
        swatch.classList.add('active');

        // Image switch
        if (image) {
          image.setAttribute(
            'srcset',
            swatch.dataset.srcset || org_srcset
          );
        }

        // ✅ THIS IS WHAT SELECTS THE VARIANT
        if (this.size_options) {
          this.current_options[this.color_index] =
            swatch.querySelector('span').innerText;
          this.updateMasterId();
        }
      };

      // Desktop
      swatch.addEventListener('mouseover', handleSwatch);

      // Mobile
      swatch.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        handleSwatch();
      });

    });
  }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
/**
 * Sawsee Quick View
 *
 * Replace the theme's complete existing QuickView block with this file.
 * This version:
 * - caches and prefetches Quick View HTML;
 * - preloads every Quick View image;
 * - removes lazy-loading from every injected Quick View image;
 * - gives mobile gallery images equal dimensions;
 * - uses object-fit: contain so images remain fully visible;
 * - resets the horizontal gallery to its true starting position.
 */
(() => {
  if (customElements.get('quick-view')) return;

  const CACHE_TTL = 2 * 60 * 1000;
  const cache = window.SawseeQuickViewCache || new Map();
  const preloadedImageUrls =
    window.SawseeQuickViewPreloadedImageUrls || new Set();

  window.SawseeQuickViewCache = cache;
  window.SawseeQuickViewPreloadedImageUrls = preloadedImageUrls;

  function installQuickViewGalleryStyles() {
    if (document.getElementById('sawsee-quick-view-gallery-styles')) return;

    const style = document.createElement('style');
    style.id = 'sawsee-quick-view-gallery-styles';
    style.textContent = `
      .product-drawer label.quick-view-variant-unavailable {
        opacity: 0.45;
        text-decoration: line-through;
      }

      @media screen and (max-width: 749px) {
        .mobile-quick-view-container .product-quick-images--container {
          box-sizing: border-box !important;
          width: calc(100% + 20px) !important;
          max-width: none !important;
          margin-left: 0 !important;
          margin-right: -20px !important;
          overflow: hidden !important;
        }

        .mobile-quick-view-container .product-quick-images {
          box-sizing: border-box !important;
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          padding: 20px 0 10px !important;
          align-items: stretch !important;
          grid-auto-columns: 110px !important;
          scroll-padding-left: 0 !important;
          scroll-behavior: auto !important;
        }

        .mobile-quick-view-container
          .product-quick-images
          > .product-quick-images__slide {
          box-sizing: border-box !important;
          width: 110px !important;
          min-width: 110px !important;
          height: 150px !important;
          padding: 0 10px 0 0 !important;
          overflow: hidden !important;
        }

        .mobile-quick-view-container
          .product-quick-images
          > .product-quick-images__slide
          .product-single__media-image {
          box-sizing: border-box !important;
          width: 100px !important;
          min-width: 100px !important;
          max-width: 100px !important;
          height: 150px !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        .mobile-quick-view-container
          .product-quick-images
          > .product-quick-images__slide
          .product-single__media-image
          img {
          position: static !important;
          display: block !important;
          width: 100% !important;
          min-width: 100% !important;
          max-width: 100% !important;
          height: 100% !important;
          margin: 0 !important;
          object-fit: contain !important;
          object-position: center center !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function preloadQuickViewImages(container) {
    if (!container) return;

    container.querySelectorAll('.product-quick-images img').forEach(image => {
      const source = image.getAttribute('src');

      if (!source || preloadedImageUrls.has(source)) return;

      preloadedImageUrls.add(source);

      const preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.loading = 'eager';
      preloadImage.src = source;
    });
  }

  function eagerlyLoadQuickViewImages(container) {
    if (!container) return;

    container.querySelectorAll('.product-quick-images img').forEach(image => {
      image.loading = 'eager';
      image.classList.remove('lazyload', 'lazyloading');

      if (image.dataset.src) {
        image.setAttribute('src', image.dataset.src);
      }

      if (image.dataset.srcset) {
        image.setAttribute('srcset', image.dataset.srcset);
      }

      if (window.lazySizes?.loader?.unveil) {
        window.lazySizes.loader.unveil(image);
      }

      image.classList.add('lazyloaded');
    });
  }

  function resetQuickViewGallery(gallery) {
    if (!gallery) return;

    gallery.style.scrollBehavior = 'auto';
    gallery.scrollLeft = 0;

    window.requestAnimationFrame(() => {
      gallery.scrollLeft = 0;
    });

    window.setTimeout(() => {
      gallery.scrollLeft = 0;
    }, 100);

    window.setTimeout(() => {
      gallery.scrollLeft = 0;
    }, 300);
  }

  function normaliseVariantMediaValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findQuickViewVariantData(container) {
    const quickViewVariantData = container.querySelector(
      'script[data-quick-view-variants]'
    );

    if (quickViewVariantData) {
      try {
        const variants = JSON.parse(quickViewVariantData.textContent);

        if (Array.isArray(variants)) return variants;
      } catch (error) {
        console.error('Quick View variant data is invalid.', error);
      }
    }

    const jsonScripts = container.querySelectorAll(
      'script[type="application/json"]'
    );

    for (const script of jsonScripts) {
      try {
        const data = JSON.parse(script.textContent);
        const variants = Array.isArray(data) ? data : data?.variants;

        if (
          Array.isArray(variants) &&
          variants.some(variant => variant?.id && variant?.options)
        ) {
          return variants;
        }
      } catch (error) {
        // This JSON belongs to another component in the product drawer.
      }
    }

    return [];
  }

  function getQuickViewVariantId(container, gallery) {
    const variantInput = container.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );

    return String(
      variantInput?.value || gallery?.dataset.initialVariantId || ''
    );
  }

  function getProductOptionNames(container) {
    const gallery = container.querySelector('.product-quick-images');
    const galleryOptionNames = (gallery?.dataset.optionNames || '')
      .split('||')
      .filter(Boolean);

    if (galleryOptionNames.length) return galleryOptionNames;

    const picker = container.querySelector(
      'variant-selects, variant-radios, product-options'
    ) || container;
    const optionNames = [];

    picker.querySelectorAll('input[name], select[name]').forEach(control => {
      const match = control.name.match(/^options\[(.+)\]$/);

      if (match && !optionNames.includes(match[1])) {
        optionNames.push(match[1]);
      }
    });

    if (optionNames.length) return optionNames;

    return Array.from(picker.querySelectorAll('fieldset')).map(fieldset => {
      const legend = fieldset.querySelector('legend')?.textContent || '';
      return legend.split(':')[0].trim();
    }).filter(Boolean);
  }

  function getVariantFeaturedMediaId(variant) {
    return String(
      variant?.featured_media?.id ||
      variant?.featured_image?.id ||
      variant?.featured_media_id ||
      ''
    );
  }

  function getSlideMediaId(slide) {
    return String(slide?.dataset.mediaId || '').split('-').pop();
  }

  function updateQuickViewVariantMedia(container) {
    const gallery = container.querySelector('.product-quick-images');
    if (!gallery) return;

    const slides = Array.from(
      gallery.querySelectorAll(':scope > .product-quick-images__slide')
    );
    const variants = findQuickViewVariantData(container);
    const variantId = getQuickViewVariantId(container, gallery);
    const variant = variants.find(item => String(item.id) === variantId);

    if (!variant || !slides.length) return;

    const optionNames = (gallery.dataset.optionNames || '').split('||');
    const normalisedOptions = (variant.options || []).map(
      normaliseVariantMediaValue
    );

    const groupedSlides = slides.filter(slide => {
      const setName = slide.dataset.setName;
      const groupName = slide.dataset.group;

      if (!setName || !groupName) return false;

      const optionIndex = optionNames.findIndex(
        name =>
          normaliseVariantMediaValue(name) ===
          normaliseVariantMediaValue(setName)
      );
      const groupValue = groupName.slice(groupName.indexOf('_') + 1);
      const normalisedGroupValue =
        normaliseVariantMediaValue(groupValue);

      if (optionIndex > -1) {
        return normalisedOptions[optionIndex] === normalisedGroupValue;
      }

      // Backwards-compatible fallback for markup without option names.
      return normalisedOptions.includes(normalisedGroupValue);
    });

    const featuredMediaId = getVariantFeaturedMediaId(variant);
    const featuredSlide = slides.find(
      slide => getSlideMediaId(slide) === featuredMediaId
    );
    const visibleSlides = groupedSlides.length
      ? groupedSlides
      : featuredSlide
        ? [featuredSlide]
        : [slides[0]];

    slides.forEach(slide => {
      const isVisible = visibleSlides.includes(slide);

      slide.hidden = !isVisible;
      slide.style.display = isVisible ? '' : 'none';
      slide.classList.toggle('is-active', isVisible);
      slide.setAttribute('aria-hidden', String(!isVisible));
    });

    resetQuickViewGallery(gallery);
  }

  function getQuickViewOptionGroups(container, optionNames) {
    const picker = container.querySelector(
      'variant-selects, variant-radios, product-options'
    ) || container;
    const groups = [];

    optionNames.forEach((optionName, optionIndex) => {
      const optionInputName = `options[${optionName}]`;
      let controls = Array.from(
        picker.querySelectorAll('input[name], select[name]')
      ).filter(control => control.name === optionInputName);

      if (!controls.length) {
        const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
        const selects = Array.from(picker.querySelectorAll('select')).filter(
          select =>
            select.name?.startsWith('options[') ||
            select.dataset.optionIndex !== undefined
        );
        const fallbackGroup = fieldsets[optionIndex] || selects[optionIndex];

        if (fallbackGroup?.tagName === 'SELECT') {
          controls = [fallbackGroup];
        } else if (fallbackGroup) {
          controls = Array.from(
            fallbackGroup.querySelectorAll('input[type="radio"]')
          );
        }
      }

      groups.push(controls);
    });

    return groups;
  }

  function getSelectedQuickViewOptions(groups) {
    return groups.map(controls => {
      const select = controls.find(control => control.tagName === 'SELECT');
      const checkedInput = controls.find(control => control.checked);

      return select?.value || checkedInput?.value || '';
    });
  }

  function isQuickViewColorChange(container, event) {
    if (!event?.target) return false;

    const optionNames = getProductOptionNames(container);
    const colorIndex = optionNames.findIndex(name => {
      const normalisedName = normaliseVariantMediaValue(name);
      return normalisedName.includes('color') ||
        normalisedName.includes('colour');
    });

    if (colorIndex < 0) return false;

    const groups = getQuickViewOptionGroups(container, optionNames);
    return (groups[colorIndex] || []).includes(event.target);
  }

  function selectFirstAvailableQuickViewSize(
    container,
    forceFirstAvailable = false
  ) {
    const variants = findQuickViewVariantData(container);
    const optionNames = getProductOptionNames(container);
    const sizeIndex = optionNames.findIndex(name =>
      normaliseVariantMediaValue(name).includes('size')
    );

    if (!variants.length || sizeIndex < 0) return false;

    const groups = getQuickViewOptionGroups(container, optionNames);
    const selectedOptions = getSelectedQuickViewOptions(groups);
    const selectedVariant = variants.find(variant =>
      variant.options.every(
        (value, index) => value === selectedOptions[index]
      )
    );

    if (selectedVariant?.available && !forceFirstAvailable) return false;

    const firstAvailableVariant = variants.find(variant =>
      variant.available &&
      variant.options.every(
        (value, index) =>
          index === sizeIndex || value === selectedOptions[index]
      )
    );

    if (!firstAvailableVariant) return false;

    const availableSize = firstAvailableVariant.options[sizeIndex];
    const sizeControls = groups[sizeIndex] || [];
    const sizeSelect = sizeControls.find(
      control => control.tagName === 'SELECT'
    );
    const sizeInput = sizeControls.find(
      control => control.value === availableSize
    );

    if (sizeSelect && sizeSelect.value !== availableSize) {
      sizeSelect.value = availableSize;
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    if (sizeInput && !sizeInput.checked) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function setQuickViewControlAvailability(control, unavailable) {
    if (control.tagName === 'SELECT') {
      Array.from(control.options).forEach(option => {
        if (option.dataset.quickViewUnavailable === 'true') {
          option.disabled = true;
        } else if (option.dataset.quickViewAvailabilityManaged === 'true') {
          option.disabled = false;
        }
      });
      return;
    }

    const label = control.labels?.[0] || null;

    control.classList.toggle('is-disabled', unavailable);
    control.classList.toggle('quick-view-variant-unavailable', unavailable);
    control.setAttribute('aria-disabled', String(unavailable));
    control.dataset.unavailable = String(unavailable);

    label?.classList.toggle('is-disabled', unavailable);
    label?.classList.toggle('quick-view-variant-unavailable', unavailable);
  }

  function updateQuickViewVariantAvailability(container) {
    const variants = findQuickViewVariantData(container);
    const optionNames = getProductOptionNames(container);

    if (!variants.length || !optionNames.length) return;

    const groups = getQuickViewOptionGroups(container, optionNames);
    const selectedOptions = getSelectedQuickViewOptions(groups);
    const colorIndex = optionNames.findIndex(name => {
      const normalisedName = normaliseVariantMediaValue(name);
      return normalisedName.includes('color') ||
        normalisedName.includes('colour');
    });
    const sizeIndex = optionNames.findIndex(name =>
      normaliseVariantMediaValue(name).includes('size')
    );

    const isOptionAvailable = (optionIndex, optionValue) =>
      variants.some(variant =>
        variant.available &&
        variant.options[optionIndex] === optionValue &&
        variant.options.every((value, index) => {
          if (index === optionIndex) return true;

          // A color remains available when it has any available size.
          if (optionIndex === colorIndex && index === sizeIndex) return true;

          return value === selectedOptions[index];
        })
      );

    groups.forEach((controls, optionIndex) => {
      const select = controls.find(control => control.tagName === 'SELECT');

      if (select) {
        Array.from(select.options).forEach(option => {
          const available = isOptionAvailable(optionIndex, option.value);

          option.dataset.quickViewAvailabilityManaged = 'true';
          option.dataset.quickViewUnavailable = String(!available);
          option.disabled = !available;
        });
        return;
      }

      controls.forEach(control => {
        const available = isOptionAvailable(optionIndex, control.value);

        setQuickViewControlAvailability(control, !available);
      });
    });

    const selectedVariant = variants.find(variant =>
      variant.options.every(
        (value, index) => value === selectedOptions[index]
      )
    );
    const addButton = container.querySelector(
      'form[action*="/cart/add"] [name="add"]'
    );

    if (addButton && selectedVariant) {
      addButton.disabled = !selectedVariant.available;
      addButton.setAttribute(
        'aria-disabled',
        String(!selectedVariant.available)
      );
    }
  }

  function setupQuickViewVariantMedia(container) {
    if (!container) return;

    container.quickViewVariantMediaController?.abort();

    const controller = new AbortController();
    container.quickViewVariantMediaController = controller;

    const synchronise = event => {
      const forceFirstAvailableSize = isQuickViewColorChange(
        container,
        event
      );

      // Variant components update the hidden variant id at different times.
      [0, 50, 200].forEach(delay => {
        window.setTimeout(
          () => {
            if (
              selectFirstAvailableQuickViewSize(
                container,
                forceFirstAvailableSize
              )
            ) {
              return;
            }

            updateQuickViewVariantMedia(container);
            updateQuickViewVariantAvailability(container);
          },
          delay
        );
      });
    };

    container.addEventListener('change', synchronise, {
      signal: controller.signal
    });

    ['variant:change', 'variant-change', 'product:variant-change'].forEach(
      eventName => {
        document.addEventListener(eventName, synchronise, {
          signal: controller.signal
        });
      }
    );

    synchronise();
  }

  function setupMainProductVariantDefaults() {
    const productContainers = new Set();

    document.querySelectorAll(
      'variant-selects, variant-radios, product-options'
    ).forEach(picker => {
      const container = picker.closest(
        '.thb-product-detail, .product-section, ' +
        '[data-section-type="product"], .shopify-section'
      ) || picker.parentElement;

      if (container) productContainers.add(container);
    });

    document.querySelectorAll('.thb-product-detail').forEach(container => {
      productContainers.add(container);
    });

    productContainers.forEach(container => {
      if (
        container.closest('#Product-Drawer') ||
        container.dataset.availableVariantDefaultsReady === 'true'
      ) {
        return;
      }

      container.dataset.availableVariantDefaultsReady = 'true';

      const synchronise = event => {
        const forceFirstAvailableSize = isQuickViewColorChange(
          container,
          event
        );

        [0, 50, 200].forEach(delay => {
          window.setTimeout(() => {
            if (
              selectFirstAvailableQuickViewSize(
                container,
                forceFirstAvailableSize
              )
            ) {
              return;
            }

            updateQuickViewVariantAvailability(container);
          }, delay);
        });
      };

      container.addEventListener('change', synchronise);
      synchronise();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      setupMainProductVariantDefaults,
      { once: true }
    );
  } else {
    setupMainProductVariantDefaults();
  }

  document.addEventListener(
    'shopify:section:load',
    setupMainProductVariantDefaults
  );

  function getCachedQuickView(href) {
    const cached = cache.get(href);

    if (cached && Date.now() - cached.createdAt < CACHE_TTL) {
      return cached.promise;
    }

    if (cached) cache.delete(href);

    const promise = fetch(href, { method: 'GET' })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Quick View request failed: ${response.status}`);
        }

        return response.text();
      })
      .then(text => {
        const responseDocument = new DOMParser().parseFromString(
          text,
          'text/html'
        );

        const content = responseDocument.querySelector(
          '#Product-Drawer-Content'
        );

        if (!content) {
          throw new Error('Quick View content was not found');
        }

        preloadQuickViewImages(content);

        return content.innerHTML;
      })
      .catch(error => {
        cache.delete(href);
        throw error;
      });

    cache.set(href, {
      createdAt: Date.now(),
      promise
    });

    return promise;
  }

  let preloadObserver = null;

  if ('IntersectionObserver' in window) {
    preloadObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;

          entry.target.preloadQuickView();
          preloadObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: '500px 0px'
      }
    );
  }

  class QuickView extends HTMLElement {
    constructor() {
      super();

      this.preloadStarted = false;
      this.boundSetupEventListener = this.setupEventListener.bind(this);
      this.boundPreloadQuickView = this.preloadQuickView.bind(this);
    }

    connectedCallback() {
      installQuickViewGalleryStyles();

      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.boundSetupEventListener);
      this.addEventListener('pointerenter', this.boundPreloadQuickView, {
        once: true,
        passive: true
      });
      this.addEventListener('focusin', this.boundPreloadQuickView, {
        once: true,
        passive: true
      });
      this.addEventListener('touchstart', this.boundPreloadQuickView, {
        once: true,
        passive: true
      });

      preloadObserver?.observe(this);
    }

    disconnectedCallback() {
      preloadObserver?.unobserve(this);
      this.removeEventListener('click', this.boundSetupEventListener);
    }

    getQuickViewDetails() {
      const productHandle = this.dataset.productHandle;
      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      href = href.replace('//products/', '/products/');

      return {
        href,
        productHandle
      };
    }

    preloadQuickView() {
      const { href, productHandle } = this.getQuickViewDetails();

      if (!href || !productHandle) return Promise.resolve(null);

      this.preloadStarted = true;

      return getCachedQuickView(href).catch(() => null);
    }

    setupEventListener(event) {
      event.preventDefault();

      const { href, productHandle } = this.getQuickViewDetails();

      if (
        !href ||
        !productHandle ||
        this.classList.contains('loading')
      ) {
        return;
      }

      this.classList.add('loading');

      getCachedQuickView(href)
        .then(sectionInnerHTML => {
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch(error => {
          console.error('Quick View could not be opened.', error);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }

    loadMissingScripts(container) {
      const loadedSources = new Set(
        Array.from(document.scripts)
          .map(script => script.src)
          .filter(Boolean)
      );

      container.querySelectorAll('script[src]').forEach(sourceScript => {
        if (!sourceScript.src || loadedSources.has(sourceScript.src)) return;

        const script = document.createElement('script');
        script.src = sourceScript.src;
        script.defer = sourceScript.defer;
        script.async = false;
        document.head.appendChild(script);
        loadedSources.add(sourceScript.src);
      });
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML || !this.drawer) return;

      const content = this.drawer.querySelector('#Product-Drawer-Content');

      if (!content) return;

      content.innerHTML = sectionInnerHTML;

      eagerlyLoadQuickViewImages(content);
      this.loadMissingScripts(content);

      const imageContainer = content.querySelector(
        '.product-quick-images--container'
      );
      const imageGallery = content.querySelector('.product-quick-images');

      resetQuickViewGallery(imageGallery);
      setupQuickViewVariantMedia(content);

      window.setTimeout(() => {
        if (window.Shopify?.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
      }, 300);

      this.body.classList.add('open-cc', 'open-quick-view');
      this.drawer.classList.add('active');

      this.drawer.querySelector('.side-panel-close')?.focus();

      window.requestAnimationFrame(() => {
        imageContainer?.classList.add('active');
        resetQuickViewGallery(imageGallery);
      });

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle
      });

      if (typeof addIdToRecentlyViewed === 'function') {
        addIdToRecentlyViewed(productHandle);
      }
    }
  }

  customElements.define('quick-view', QuickView);
})();

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});




  document.addEventListener('DOMContentLoaded', function() {
    var readMoreLink = document.querySelector('.read-more-toggle');
    var fullText = document.querySelector('.full-description');
    var excerpt = document.querySelector('.short-description');
    
    if (readMoreLink) {
        readMoreLink.addEventListener('click', function(e) {
            e.preventDefault();
            if (fullText.style.display === 'none') {
                fullText.style.display = 'inline';
                excerpt.style.display = 'none';
                this.textContent = 'Read Less';
            } else {
                fullText.style.display = 'none';
                excerpt.style.display = 'inline';
                this.textContent = 'Read More';
            }
        });
    }
});



